import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-link.js';
import { projectConfig } from '@chancenwerk/config.js';
import { imprintText } from '@chancenwerk/db/imprint.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import logo from '../assets/logo_chancenwerk_white.svg';

/**
 * @deprecated has been split into <chancen-page-impressum> and <chancen-page-privacy>
 * @customElement chancen-page-impressum-privacy
 */
@customElement('chancen-page-impressum-privacy')
export class ChancenPageImpressumPrivacy extends ChemistryLitElement {
  override render() {
    return html`
      <cr-flex
        horizontal
        space-between
        space="md"
        ${css({ position: 'absolute', bottom: '0', background: '#006359', zIndex: '999' })}
        padding="md"
      >
        <cr-flex ${css({ width: '20%' })}>
          <!--
          placeholder
  -->
        </cr-flex>
        <cr-text ${css({ color: 'white', maxWidth: '60%' })}>
          Chancenwerk e.V. ist Träger der freien Jugendhilfe und eine gemeinnützige Einrichtung, die in der Rechtsform
          eines eingetragenen Vereins organisiert ist. Geschäftsführender Vorstandsvorsitz: Murat Vural • Vereinssitz:
          Am Markt 18, 44575 Castrop-Rauxel • 02305 902 394 0 kontakt@chancenwerk.org • Vereinsregister: 11477
          (Amtsgericht Dortmund) Kontoverbindung: IBAN: DE45430500010033415977, BIC: WELADED1B0C, Sparkasse Bochum
        </cr-text>
        <cr-image ${css({ width: '20%' })} is-url .value=${logo} mode="width"></cr-image>
      </cr-flex>
      <chancen-page-privacy bottomPadding></chancen-page-privacy>
      </cr-flex>
    `;
  }
}

@customElement('chancen-page-privacy')
export class ChancenPagePrivacy extends ChemistryLitElement {
  @state() size = new WindowSizeController(this);

  @property({ type: Boolean }) bottomPadding = false;

  override styles() {
    return [
      ...super.styles(),
      {
        'cr-h2, cr-h3': {
          color: '#006359',
        },
      },
    ];
  }

  override render() {
    return html`
      <cr-flex padding="${this.size.mobile ? 'md' : 'xxl'}" space="xl">
        <cr-flex horizontal space-between ${css({ flexWrap: 'wrap' })}>
          <cr-h2> DATENSCHUTZ-INFORMATION ZUR NUTZUNG VON CHANCENCAMPUS.ORG </cr-h2>
        </cr-flex>
        <cr-flex space="md">
          <cr-text>
            Die Datenschutz-Grundverordnung – oder kurz DS-GVO – verpflichtet uns dazu, dir einige Informationen über
            die Verarbeitung deiner personenbezogenen Daten zu geben.
          </cr-text>
          <cr-text>
            Diese Informationen sollen es dir ermöglichen, besser über die Verarbeitung deiner personenbezogenen Daten
            Bescheid zu wissen, die bei dem Betrieb des CHANCENcampus anfallen.
          </cr-text>
        </cr-flex>
        <cr-h2> 1. Wer ist verantwortlich für die Verarbeitung der personenbezogenen Daten? </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Für die Verarbeitung verantwortlich ist der Chancenwerk e.V. Du erreichst uns unter der Anschrift Am Markt
            18, 44575 Castrop-Rauxel und der E-Mail-Adresse kontakt@chancenwerk.org.
          </cr-text>
          <cr-text>
            Chancenwerk wird gesetzlich vertreten durch den Vereinsvorstand, dieser wiederum durch den Vorsitzenden
            Murat Vural.
          </cr-text>
        </cr-flex>
        <cr-h2> 2. An wen kann ich mich wenden, wenn ich Fragen zum Datenschutz habe? </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Du kannst dich entweder direkt an uns (datenschutz@chancenwerk.org) oder an unseren Datenschutzbeauftragten
            wenden: SPIRIT LEGAL Rechtsanwaltsgesellschaft mbH, Rechtsanwalt und Datenschutzbeauftragter Peter Hense,
          </cr-text>
          <cr-text bold> Postanschrift: </cr-text>

          <cr-text> Datenschutzbeauftragter c/o Chancenwerk e.V., Am Markt 18, 44575 Castrop-Rauxel </cr-text>

          <cr-text bold> Kontaktaufnahme über das verschlüsseltes Onlineformular: </cr-text>

          <cr-text>
            <a href="https://www.spiritlegal.com/de/datenschutzbeauftragter-anfragen.html">
              Datenschutzbeauftragten kontaktieren
            </a>
          </cr-text>
        </cr-flex>

        <cr-h2>
          3. Zu welchem Zweck und auf welcher Rechtsgrundlage erfolgt die Verarbeitung der personenbezogenen Daten?
        </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Wir stellen dir unseren CHANCENcampus im Rahmen verschiedener Angebote zur Verfügung: Vielleicht nutzt du
            den CHANCENcampus als Teilnehmer:innen unserer Lernkaskade, der CHANCENschule oder vielleicht hast du den
            Zugang auch von deiner Schule erhalten.
          </cr-text>
          <cr-text>
            Nachfolgend findest du Informationen, zu welchen Zwecken und auf welcher Rechtsgrundlage wir deine Daten auf
            dem CHANCENcampus verarbeiten. Je nach Angebot kann es sein, dass nicht alle der folgenden Funktionen für
            dich relevant sind.
          </cr-text>
        </cr-flex>
        <cr-flex space="md" ${css({ paddingLeft: this.spacing.xl })}>
          <cr-h3> 3.1 Protokolldaten zur Bereitstellung des CHANCENcampus </cr-h3>
          <cr-text>
            Beim jedem Besuch auf dem CHANCENcampus werden bestimmte Zugriffsdaten verarbeitet, damit der CHANCENcampus
            angezeigt werden kann. Die folgenden Daten werden hierbei verarbeitet:
          </cr-text>
          <cr-flex space="md" ${css({ paddingLeft: this.spacing.xl })}>
            <li><cr-text>Browsertyp/ Browserversion</cr-text></li>
            <li><cr-text>verwendetes Betriebssystem</cr-text></li>
            <li><cr-text>Sprache und Version der Browsersoftware</cr-text></li>
            <li><cr-text>Datum und Uhrzeit des Zugriffs</cr-text></li>
            <li><cr-text>Hostname des zugreifenden Endgeräts</cr-text></li>
            <li><cr-text>IP-Adresse</cr-text></li>
            <li><cr-text>Inhalt der Anforderung (konkrete Webseite)</cr-text></li>
            <li><cr-text>Zugriffsstatus/HTTP-Statuscode</cr-text></li>
            <li><cr-text>Websites, die über die Website aufgerufen werden</cr-text></li>
            <li><cr-text>Referrer URL (die zuvor besuchte Website)</cr-text></li>
            <li><cr-text>Meldung, ob der Aufruf erfolgreich war und Übertragene Datenmenge</cr-text></li>
          </cr-flex>
          <cr-text>
            Die vorübergehende Verarbeitung dieser Daten ist notwendig, um den CHANCENcampus technisch auf Deinem
            Endgerät darzustellen.
          </cr-text>
          <cr-text>
            Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 S. 1 b) DSGVO. Die Verarbeitung dieser Daten ist zur
            Bereitstellung des CHANCENcampus erforderlich. Bei Nichtbereitstellung der Daten kannst du den CHANCENcampus
            nicht nutzen.
          </cr-text>
          <cr-text>
            Eine Speicherung der Daten über Deine Sitzung hinaus erfolgt nicht. Sie werden lediglich anonymisiert zu
            statistischen Zwecken weiterverarbeitet. Die Daten zur Bereitstellung des CHANCENcampus werden nicht an
            Dritte weitergegeben. Sie werden jedoch von unseren Dienstleistern verarbeitet, die uns bei der
            Zurverfügungstellung des CHANCENcampus unterstützen (siehe dazu Ziffer 4.)
          </cr-text>

          <cr-h3 ${css({ paddingTop: this.spacing.xl })}> 3.2 Anmeldedaten für den CHANCENcampus </cr-h3>
          <cr-text>
            Um unseren CHANCENcampus zu nutzen, musst du dich zunächst anmelden. Bei deiner ersten Anmeldung wirst du
            gebeten, ein Passwort zu vergeben. Bei jeder Anmeldung auf dem CHANCENcampus verarbeiten wir die folgenden
            Daten:
          </cr-text>
          <cr-flex space="md" ${css({ paddingLeft: this.spacing.xl })}>
            <li>
              <cr-text> Dein von uns vergebener Nutzername </cr-text>
            </li>
            <li>
              <cr-text> Dein selbst gewähltes Passwort </cr-text>
            </li>
          </cr-flex>
          <cr-text>
            Um dir die für dich passenden Aufgaben zur Verfügung zu stellen, verarbeiten wir darüber hinaus:
          </cr-text>
          <cr-flex space="md" ${css({ paddingLeft: this.spacing.xl })}>
            <li>
              <cr-text> Dein von uns vergebener Nutzername </cr-text>
            </li>
            <li>
              <cr-text> Dein selbst gewähltes Passwort </cr-text>
            </li>
          </cr-flex>

          <cr-text>
            Soweit wir deine E-Mail-Adresse nicht bereits haben (z.B. von deiner Teilnahme in der Lernkaskade), bitten
            wir dich zudem um Eingabe einer E-Mail-Adresse, damit wir dich kontaktieren können.
          </cr-text>
          <cr-text>
            Deine Daten werden zu dem Zweck verarbeitet, den Zugang zum CHANCENcampus und zu allen Funktionen
            sicherzustellen und eine effiziente, ungehinderte und komfortable Nutzung des CHANCENcampus zu ermöglichen.
            Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 b) DSGVO. Die Bereitstellung deiner Daten ist
            für die Nutzung des CHANCENcampus verpflichtend. Wenn du uns keine Daten zur Verfügung stellst, kann es
            sein, dass du den CHANCENcampus oder verschiedene Funktionen nicht nutzen kannst.
          </cr-text>

          <cr-text>
            Diese Daten werden gespeichert, so lange dein Account besteht. Wenn du die Nutzung des CHANCENcampus
            beendest – z.B. weil du nicht mehr an der Lernkaskade teilnimmst oder die Kooperation mit deiner Schule
            endet – bleibt dein Account mit den genannten Daten noch bis zum Ablauf des folgenden Kalenderjahres
            erhalten und wird dann gelöscht. Die Daten zur Bereitstellung des CHANCENcampus werden nicht an Dritte
            weitergegeben. Sie werden jedoch von unseren Dienstleistern verarbeitet, die uns bei der
            Zurverfügungstellung des CHANCENcampus unterstützen (siehe dazu Ziffer 4.)
          </cr-text>

          <cr-h3 ${css({ paddingTop: this.spacing.xl })}> 3.3 Lerndaten auf dem CHANCENcampus </cr-h3>
          <cr-text>
            Bei deinen Lernsitzungen auf dem CHANCENcampus verarbeiten wir Daten, damit du auf dem CHANCENcampus lernen
            kannst. Dazu gehören deine Eingaben in den Aufgaben, die du auf dem CHANCENcampus erledigst. Weiterhin
            können dir von deinen Lernkoordinator:innen oder Lehrenden Aufgaben zugewiesen werden. Wenn du an unserer
            digitalen Lernförderung teilnimmst, informieren wir dich auf dem CHANCENcampus zudem über anstehenden
            Events.
          </cr-text>

          <cr-text>
            Deine Daten werden zu dem Zweck verarbeitet, den Zugang zum CHANCENcampus und zu allen Funktionen
            sicherzustellen und eine effiziente, ungehinderte und komfortable Nutzung des CHANCENcampus zu ermöglichen.
            Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 b) DSGVO. Die Bereitstellung deiner Daten ist
            für die Nutzung des CHANCENcampus verpflichtend. Wenn Du uns keine Daten zur Verfügung stellst, kann es
            sein, dass du den CHANCENcampus oder verschiedene Funktionen nicht nutzen kannst
          </cr-text>

          <cr-text>
            Deine Eingaben im CHANCENcampus speichern wir mindestens solange du den CHANCENcampus nutzt. Nach dem Ende
            Deiner Nutzung bewahren wir die Daten noch bis zum Ablauf des folgenden Jahres auf. Diese Speicherung dient
            dem Zweck, Dir die Daten wieder zur Verfügung zu stellen, wenn du den CHANCENcampus nach kurzer
            Unterbrechung doch noch einmal nutzen möchtest und zur Dokumentation im Rahmen von finanziellen Förderungen.
            Anschließend werden die Daten anonymisiert und dienen in anonymisierter Form noch der Evaluation unseres
            Lernförderangebotes und der Forschung.
          </cr-text>

          <cr-text>
            Wenn du an der Lernkaskade oder CHANCENschule teilnimmst, werden deine Lerndaten an deine
            Lernkoordinator:innen weitergegeben. Wenn Ddu den Zugang zum CHANCENcampus über die Schule erhalten hast,
            haben Deine Lehrenden Zugriff auf Lerndaten. Die Daten werden zudem von unseren Dienstleistern verarbeitet,
            die uns bei der Zurverfügungstellung des CHANCENcampus unterstützen (siehe dazu Ziffer 4.)
          </cr-text>

          <cr-h3 ${css({ paddingTop: this.spacing.xl })}> 3.4 Lernverlaufsdiagnostik </cr-h3>
          <cr-text>
            Über den CHANCENcampus ist es uns möglich, deinen Lernverlauf mithilfe von Diagnosetests zu analysieren. Das
            dient uns dazu, dass wir dir passende Aufgaben geben können und dich bei deinen Stärken und Schwächen besser
            zu unterstützen. Somit bekommst du Aufgaben, die deinem Lernstand entsprechen. Die Rechtsgrundlage für diese
            Datenverarbeitung ist Art. 6 Abs. 1 b) DSGVO.. Die Bereitstellung deiner Daten ist für die Nutzung des
            CHANCENcampus verpflichtend. Wenn Ddu uns keine Daten zur Verfügung stellst, kann die
            Lernverflaufsdiagnostik nicht durchgeführt werden.
          </cr-text>

          <cr-text>
            Deine Lernverlaufsdiagnostik speichern wir mindestens solange du den CHANCENcampus nutzt. Nach dem Ende
            Deiner Nutzung bewahren wir die Daten noch bis zum Ablauf des folgenden Jahres auf. Diese Speicherung dient
            dem Zweck, Dir die Daten wieder zur Verfügung zu stellen, wenn du den CHANCENcampus nach kurzer
            Unterbrechung doch noch einmal nutzen möchtest und zur Dokumentation im Rahmen von finanziellen Förderungen.
            Anschließend werden die Daten anonymisiert und dienen in anonymisierter Form noch der Evaluation unseres
            Lernförderangebotes und der Forschung.
          </cr-text>

          <cr-text>
            Wenn du an der Lernkaskade oder CHANCENschule teilnimmst, werden diese Daten an deine Lernkoordinator:innen
            weitergegeben. Wenn du den Zugang zum CHANCENcampus über die Schule erhalten hast, haben deine Lehrenden
            Zugriff auf die Daten aus der Lernverlaufsdiagnostik.
          </cr-text>
        </cr-flex>
        <cr-h2> 4. Kontaktaufnahme mit Lernenden per E-Mail und anderen Kommunikationskanälen </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Im Rahmen deiner Nutzung des CHANCENcampus kann es vorkommen, dass wir dich außerhalb des CHANCENcampus
            kontaktieren müssen, z.B. um dir Zugangsdaten zum CHANCENcampus mitzuteilen, dein Passwort zurückzusetzen
            oder dir sonst Informationen zur Nutzung des CHANCENcampus mitzuteilen. Diese Kontaktaufnahme erfolgt in der
            Regel per E-Mail. Die Rechtsgrundlage für diese Datenverarbeitung ist Art. 6 Abs. 1 b) DSGVO. Die
            Bereitstellung deiner Daten ist für die Nutzung des CHANCENcampus verpflichtend. Wenn du uns keine Daten zur
            Verfügung stellst, kannst du den CHANCENcampus nicht nutzen, weil wir dich sonst nicht auf anderem Wege
            kontaktieren können.
          </cr-text>
          <cr-text>
            Für den Versand der E-Mails nutzen wir in der Regel „Postmark“, einen E-Mail- Versanddienst der AC PM LLC (1
            N Dearborn Street, Suite 500, Chicago, IL 60602, USA). AC PM LLC verarbeitet deine Daten auch in den USA.
            Für die USA existiert ein Angemessenheitsbeschluss der Europäischen Kommission, wofür AC PM LLC auch
            zertifiziert ist. Zusätzlich haben wir mit AC PM LLC Standardvertragsklauseln abgeschlossen, um AC PM LLC
            auf ein angemessenes Datenschutzniveau zu verpflichten
          </cr-text>

          <cr-text>
            Zur Kontaktaufnahme mit den Lernenden (d.h. Informationen über Aktionen, Kurserinnerungen etc.) bedient sich
            der Verantwortliche eines technischen Dienstleisters, an den wir Deine E-Mail-Adresse, die du bei der
            Anmeldung zu CHANCENcampus angibst, weiterleiten. Diese Weitergabe erfolgt auf Grundlage von Art. 6 Abs. 1
            S. 1 f) DS-GVO und dient unserem berechtigten Interesse an der Nutzung einer effektiven, sicheren und
            nutzerfreundlichen Kommunikation.
          </cr-text>
        </cr-flex>
        <cr-h2> 5. Wer hat Zugriff auf meine personenbezogenen Daten? </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Deine Daten werden von unseren Mitarbeitern sowie gegebenenfalls von externen Dienstleistern verarbeitet zur
            Erbringung der Dienste auf dem CHANCENcampus. Unsere Dienstleister sind:
          </cr-text>
          <cr-flex space="md" ${css({ paddingLeft: this.spacing.xl })}>
            <li>
              <cr-text> netcup GmbH, Daimlerstraße 25, 76185 Karlsruhe (Hoster der Plattform) </cr-text>
            </li>
            <li>
              <cr-text>
                Adornis Ventures GmbH, Am Sand 14, 61184 Karben (Softwarentwickler, Support der Plattform)
              </cr-text>
            </li>
          </cr-flex>
          <cr-text>
            Diese Dienstleister werden als Auftragsverarbeiter nach Art. 28 DS-GVO für uns tätig und wir haben mit ihm
            einen entsprechenden Vertrag zur Auftragsverarbeitung geschlossen, um deine Rechte zu schützen.
          </cr-text>
          <cr-text>
            Darüber hinaus haben auf gewissen Daten (Freitextaufgaben, Lernverlaufsdiagnostik) auch deine
            Lernkoordinator:innen und Lehrenden Einsichtsrechte (siehe dazu in den Ziffern 3.3 und 3.4).
          </cr-text>
        </cr-flex>
        <cr-h2> 6. Wo werden die Daten verarbeitet? </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Sämtliche Server, auf denen deine Daten verarbeitet werden befinden sich in Deutschland. Eine Übermittlung
            der Daten in Drittländer außerhalb der EU findet nicht statt.
          </cr-text>
          <cr-text>
            Darüber hinaus werden die Daten an unsere Auftragsverarbeiter nach Art. 28 DS-GVO weitergegeben.
          </cr-text>
        </cr-flex>
        <cr-h2> 7. Wie lange werden meine Daten gespeichert? </cr-h2>
        <cr-flex space="md">
          <cr-text>
            In deinem Account werden die Anmeldedaten, Lerndaten sowie deine Ergebnisse aus der Lernverlaufsdiagnostik
            gespeichert. Alle übrigen Daten werden am Ende deines Besuches auf dem CHANCENcampus gelöscht. Wenn du die
            Nutzung des CHANCENcampus beendest – z.B. weil du nicht mehr an der Lernkaskade teilnimmst oder die
            Kooperation mit deiner Schule endet – bleibt dein Account mit den genannten Daten noch bis zum Ablauf des
            folgenden Kalenderjahres erhalten. Anschließend werden die Daten anonymisiert.
          </cr-text>
        </cr-flex>
        <cr-h2> 8. Welche Rechte habe ich? </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Wenn es um Datenschutz geht, hast du ziemlich viele Rechte. In der DS-GVO gibt es einige Artikel, die sich
            nur damit beschäftigen und wir müssen dich darüber entsprechend informieren. Hier hast du einen Überblick
            über deine Rechte, die du uns gegenüber jederzeit geltend machen kannst.
          </cr-text>
          <cr-flex space="md" ${css({ paddingLeft: this.spacing.xl })}>
            <li>
              <cr-text>
                Recht auf Auskunft (Artikel 15 DS-GVO): wir teilen dir auf Anfrage mit, welche Daten wir von dir
                gespeichert haben und was wir mit ihnen machen
              </cr-text>
            </li>
            <li>
              <cr-text>
                Recht auf Berichtigung (Artikel 16 DS-GVO): falls wir falsche Angaben von dir gespeichert haben, kannst
                du eine Anpassung verlangen
              </cr-text>
            </li>
            <li>
              <cr-text>
                Löschung (Artikel 17 DS-GVO): wenn du nicht mehr an der digitalen Lernförderung teilnehmen möchtest,
                kannst du die Löschung deiner Daten verlangen
              </cr-text>
            </li>
            <li>
              <cr-text>
                Einschränkung der Verarbeitung (Artikel 18 DS-GVO): wenn du etwas Bestimmtes nicht mehr akzeptieren
                willst, kannst du eine Einschränkung der Verarbeitung verlangen
              </cr-text>
            </li>
            <li>
              <cr-text>
                Datenübertragung (Artikel 20 DS-GVO): du kannst von uns verlangen, dass wir deinen Datensatz an dich
                übergeben
              </cr-text>
            </li>
          </cr-flex>
          <cr-text>
            Wir haben uns Gedanken gemacht, ob wir deine personenbezogenen Daten verarbeiten dürfen. Falls du bei einer
            bestimmten Verarbeitung der Meinung bist, dass wir das nicht dürfen, kannst du uns das mitteilen (oder
            anders gesagt der Verarbeitung widersprechen). Wir prüfen das dann und geben dir Bescheid. Falls wir in
            deinem persönlichen Einzelfall zu dem Ergebnis kommen, dass wir deine Daten tatsächlich nicht verarbeiten
            dürfen, werden wir das natürlich nicht mehr tun.
          </cr-text>
          <cr-text>
            Du kannst deine Rechte jederzeit ausüben. Das heißt allerdings nicht, dass sie auch erfüllt werden. Du
            kannst z.B. nicht die Einschränkung der Verarbeitung verlangen und gleichzeitig an der digitalen
            Lernförderung über Big Blue Button teilnehmen.
          </cr-text>
          <cr-text>
            Du hast das Recht, dich jederzeit bei einer Datenschutzaufsichtsbehörde zu beschweren. Hierzu gehört auch
            die für den Verantwortlichen zuständige Datenschutzaufsichtsbehörde:
          </cr-text>
          <cr-text>
            Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen, Postfach 200444, 40102
            Düsseldorf oder: Kavalleriestraße 2-4, 40213 Düsseldorf, Telefon: 0211/38424-0, E-Mail:
            <cr-link href="mailto:poststelle@ldi.nrw.de"> <cr-text> poststelle@ldi.nrw.de </cr-text> </cr-link>,
            <cr-link href="https://www.ldi.nrw.de">
              <cr-text> https://www.ldi.nrw.de </cr-text>
            </cr-link>
          </cr-text>
        </cr-flex>

        ${this.bottomPadding ? `<cr-flex ${css({ height: '70px' })}></cr-flex>` : ''}
      </cr-flex>
    `;
  }
}

@customElement('chancen-page-impressum')
export class ChancenPageImpressum extends ChemistryLitElement {
  override styles() {
    return [
      ...super.styles(),
      {
        'cr-h2, cr-h3': {
          color: '#006359',
        },
      },
    ];
  }

  override render() {
    return html`
      <cr-flex space="xl" padding="xxl">
        <cr-h2>Impressum</cr-h2>
        <cr-text> ${imprintText} </cr-text>
      </cr-flex>
    `;
  }
}

@customElement('chancen-page-terms-of-use')
export class ChancenPageTermsOfUse extends ChemistryLitElement {
  override styles() {
    return [
      ...super.styles(),
      {
        'cr-h2, cr-h3': {
          color: '#006359',
        },
      },
    ];
  }

  @state() size = new WindowSizeController(this);

  override render() {
    return html`
      <cr-flex padding="${this.size.mobile ? 'md' : 'xxl'}" space="xl">
        <cr-flex horizontal space-between ${css({ flexWrap: 'wrap' })}>
          <cr-h2> Nutzungsbedingungen CHANCENcampus </cr-h2>
        </cr-flex>
        <cr-flex space="md">
          <cr-text>
            Der CHANCENcampus ist die digitale Lernplattform des Chancenwerk e.V., die Teilnehmenden aus verschiedenen
            Lernförderangeboten zur Verfügung steht (im Folgenden „CHANCENcampus“). Auf dem CHANCENcampus finden Kinder
            und Jugendliche Übungsaufgaben zum Lernen. Das Angebot richtet sich an Schüler:innen aller Jahrgangsstufen.
          </cr-text>
          <cr-text> Für die Nutzung des CHANCENcampus gelten die nachstehenden Nutzungsbedingungen: </cr-text>
        </cr-flex>
        <cr-h2> 1. Anbieter </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Anbieter des CHANCENcampus ist der Chancenwerk e.V., Am Markt 18, 44575 Castorp-Rauxel (im Folgenden:
            „Chancenwerk e.V.“).
          </cr-text>
        </cr-flex>
        <cr-h2> 2. Anmeldung und Teilnahmeberechtigung </cr-h2>
        <cr-flex space="md">
          <cr-text> Eine Nutzung des CHANCENcampus ist nur nach erfolgreicher Anmeldung zulässig. </cr-text>
          <cr-text>
            Nutzt du den CHANCENcampus im Rahmen unserer eigenen Lernförderangebote wie der Lernkaskade oder der
            CHANCENschule, ist der CHANCENcampus Teil dieses Lernförderangebots und du erhältst du deinen Benutzernamen
            vom Chancenwerk e.V. Darüber hinaus benötigst du für die Anmeldung lediglich ein Passwort, welches du bei
            deinem ersten Besuch selbst wählen kannst.
          </cr-text>
          <cr-text>
            Nutzt du den CHANCENcampus im Rahmen einer unserer Kooperationen mit Schulen, erhältst du von deiner Schule
            einen Link zum Anmeldeformular des CHANCENcampus. Zum Anlegen deines Nutzeraccounts benötigen wir die
            folgenden Angaben
          </cr-text>
          <cr-flex space="md" ${css({ paddingLeft: this.spacing.xl })}>
            <li><cr-text>Vor- und Nachname, aus welchen Chancenwerk deinen Benutzernamen generiert</cr-text></li>
            <li><cr-text>Schule</cr-text></li>
            <li><cr-text>Jahrgangsstufe</cr-text></li>
            <li><cr-text>E-Mail-Adresse</cr-text></li>
          </cr-flex>
          <cr-text>
            Außerdem benötigst du für deine Anmeldung ein Passwort, dass du im Rahmen der Anmeldung selbst wählen
            kannst.
          </cr-text>
          <cr-text>
            Die E-Mail-Adresse benötigen wir, damit wir dich identifizieren und im Zusammenhang mit deiner Nutzung des
            CHANCENcampus kontaktieren können (z.B. Zusendung von Zugangsdaten, Passwortänderung oder sonstige
            nutzungsbezogene Informationen).
          </cr-text>
        </cr-flex>

        <cr-h2> 3. Bereitstellung des CHANCENcampus </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Nach Abschluss deiner Anmeldung kannst du auf dem CHANCENcampus folgende Funktionen nutzen:
          </cr-text>
          <cr-flex space="md" ${css({ paddingLeft: this.spacing.xl })}>
            <li>
              <cr-text>
                Du kannst dir Lernaufgaben aussuchen und diese bearbeiten. Bei den meisten Aufgaben bekommst du direkt
                angezeigt, ob deine Antwort richtig oder falsch war. Darüber hinaus gibt es auch sogenannten
                Freitextaufgaben, wo du selbst eine Antwort formulieren musst. Deine Ergebnisse und Eingaben können auch
                deine Lernkoordinator:innen (Lernkaskade, CHANCENschule) oder Lehrenden (Kooperation mit Schulen)
                einsehen. Du kannst alle Aufgaben im CHANCENcampus so oft machen, wie du Lust hast. Außerdem können dir
                deine Lernkoordinator:innen (Lernkaskade, CHANCENcampus) oder Lehrenden (Kooperation mit Schulen) auch
                bestimmte Aufgaben vorschlagen.
              </cr-text>
            </li>
            <li>
              <cr-text>
                Du kannst an der Lernverlaufsdiagnostik teilnehmen. Das ist ein Test, mit dem wir ermitteln, was du
                besonders gut kannst und wo du noch Unterstützung brauchst. Wenn du später noch einmal einen solchen
                Test machst, können wir zudem vergleichen, wo du dich verbessert hast. Die Daten aus der
                Lernverlaufsdiagnostik speichern wir und stellen sie auch deinen Lernkoordinator:innen (Lernkaskade,
                CHANCENschule) oder Lehrenden (Kooperation mit Schulen) zu Verfügung.
              </cr-text>
            </li>
            <li>
              <cr-text>
                Wenn du unsere digitale Lernförderung nutzt, werden dir auf dem CHANCENcampus zudem auch die Termine für
                die nächsten Events angezeigt.
              </cr-text>
            </li>
          </cr-flex>
          <cr-text>
            Für die Nutzung des CHANCENcampus entstehen keine gesonderten Nutzungsgebühren, d.h. die Nutzung ist im
            Rahmen des jeweiligen Lernförderprogramms kostenfrei.
          </cr-text>
          <cr-text>
            Der Chancenwerk e.V. behält sich vor, den CHANCENcampus weiterzuentwickeln, Aufgaben oder Funktionen zu
            ändern, abzustellen oder neue Aufgaben oder Funktionen hinzuzufügen. Er darf sich zur Leistungserbringung
            jederzeit und im beliebigen Umfang Dritter bedienen.
          </cr-text>
          <cr-text>
            Der Chancenwerk e.V. kann nicht gewährleisten, dass der CHANCENcampus ununterbrochen erreichbar ist. Der
            CHANCENcampus kann insbesondere aufgrund von äußeren Umständen z.B. technischen Störungen oder Ausfällen
            ohne Verschulden des Chancenwerk e.V. nicht verfügbar sein. Wegen solcher äußeren Umstände bestehen keine
            Ansprüche gegenüber dem Chancenwerk e.V.
          </cr-text>
        </cr-flex>
        <cr-h2> 4. Pflichten der Teilnehmenden </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Für die Nutzung des CHANCENcampus benötigst du einen Internetzugang und ein internetfähiges Endgerät, z.B.
            Computer, Laptop, Tablet oder Smartphone.
          </cr-text>

          <cr-text>
            Du bist verpflichtet, deine Zugangsdaten geheim zu halten, sorgfältig aufzubewahren und nicht an andere
            Personen weiterzugeben.
          </cr-text>
          <cr-text>
            Der CHANCENcampus darf nur zur Teilnahme an den Lernförderangeboten genutzt werden. Eine kommerzielle oder
            gewerbliche Nutzung ist nicht gestattet. Insbesondere ist es nicht gestattet, Aufgaben und Informationen zu
            kopieren oder sonst zu vervielfältigen oder weiterzuverbreiten.
          </cr-text>
        </cr-flex>
        <cr-h2> 5. Maßnahmen bei Verletzungshandlungen </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Bestehen konkrete Anhaltspunkte, dass du gesetzliche Vorschriften, Rechte Dritter oder diese
            Nutzungsbedingungen verletzt, der Chancenwerk e.V. berechtigt, eine oder mehrere der folgenden Maßnahmen zu
            ergreifen:
          </cr-text>
          <cr-flex space="md" ${css({ paddingLeft: this.spacing.xl })}>
            <li>
              <cr-text> Verwarnung </cr-text>
            </li>
            <li>
              <cr-text> Vorübergehende Sperrung oder endgültige Löschung des Accounts; </cr-text>
            </li>
          </cr-flex>
          <cr-text>
            Bei der Wahl einer Maßnahme berücksichtigt der Chancenwerk e.V. deine berechtigten Interessen, insbesondere
            ob Anhaltspunkte dafür vorliegen, dass du den Verstoß nicht verschuldet hast. Wenn dein Account endgültig
            gesperrt wurde, besteht kein Anspruch auf Wiederherstellung des gesperrten Accounts. Eine erneute Anmeldung
            ist dann nicht zulässig.
          </cr-text>

          <cr-text>
            Ergreift der Chancenwerk e.V. hinsichtlich eines von dir verübten Verstoßes gegen diese Nutzungsbedingungen
            keine Maßnahmen, verzichtet der Chancenwerk e.V. damit nicht zugleich auf das Recht, hinsichtlich aktueller,
            künftiger bzw. ähnlicher Verstöße Maßnahmen zu ergreifen.
          </cr-text>
        </cr-flex>
        <cr-h2> 6. Haftung </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Soweit sich aus diesen Nutzungsbedingungen einschließlich der nachfolgenden Bestimmungen nichts anderes
            ergibt, haftet der Chancenwerk e.V. bei einer Verletzung von vertraglichen und außervertraglichen Pflichten
            nach den gesetzlichen Vorschriften.
          </cr-text>

          <cr-text>
            Auf Schadensersatz haftet der Chancenwerk e.V. – gleich aus welchem Rechtsgrund – im Rahmen der
            Verschuldenshaftung bei Vorsatz und grober Fahrlässigkeit. Bei einfacher Fahrlässigkeit haftet der
            Chancenwerk e.V. vorbehaltlich eines milderen Haftungsmaßstabs nach gesetzlichen Vorschriften (z.B. für
            Sorgfalt in eigenen Angelegenheiten) nur
          </cr-text>
          <cr-flex space="md" ${css({ paddingLeft: this.spacing.xl })}>
            <li>
              <cr-text> für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit, </cr-text>
            </li>
            <li>
              <cr-text>
                für Schäden aus der nicht unerheblichen Verletzung einer wesentlichen Vertragspflicht (Verpflichtung,
                deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren
                Einhaltung der Vertragspartner regelmäßig vertraut und vertrauen darf); in diesem Fall ist die Haftung
                des Chancenwerk e.V. jedoch auf den Ersatz des vorhersehbaren, typischerweise eintretenden Schadens
                begrenzt.
              </cr-text>
            </li>
          </cr-flex>

          <cr-text>
            Die vorstehenden Haftungsbeschränkungen gelten auch bei Pflichtverletzungen durch bzw. zugunsten von
            Personen, deren Verschulden der Chancenwerk e.V. nach gesetzlichen Vorschriften zu vertreten hat. Sie gelten
            nicht, soweit der Chancenwerk e.V. einen Mangel arglistig verschwiegen hat oder nach gesetzlich zwingenden
            Regelungen haftet.
          </cr-text>

          <cr-text>
            Sämtliche Inhalte auf dem CHANCENcampus werden mit der gebotenen Sorgfalt und nach bestem Wissen von
            Fachkräften erstellt. Soweit auf dem CHANCENcampus mittels Links auf andere Internetseiten verwiesen wird,
            übernimmt der Chancenwerk e.V. keine Gewähr für die fortwährende Aktualität, Richtigkeit und Vollständigkeit
            der verlinkten Inhalte, da diese Inhalte außerhalb des Verantwortungsbereichs des Chancenwerk e.V. liegen.
            Sollten solche Inhalte aus deiner Sicht gegen geltendes Recht verstoßen oder unangemessen sein, teil uns
            dies bitte mit.
          </cr-text>
        </cr-flex>
        <cr-h2> 7. Löschung und Kündigung </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Du kannst deinen Nutzungsvertrag für den CHANCENcampus jederzeit kündigen. Der Chancenwerk e.V. ist
            berechtigt, den Nutzungsvertrag jederzeit mit einer Frist von 30 Tagen zum Monatsende zu kündigen. Das Recht
            zur außerordentlichen Kündigung bleibt unberührt.
          </cr-text>
          <cr-text>
            Mit Beendigung des Nutzungsvertrages erfolgt die Sperrung bzw. die Löschung des Accounts. Informationen zur
            Speicherdauer von personenbezogenen Daten nach Sperrung oder Löschung des Accounts findest du in unseren
            Datenschutzinformationen (Ziffer 8). Das Recht des Chancenwerk e.V. zur Sperrung des Accounts (hierzu Ziffer
            5) bleibt unberührt.
          </cr-text>
        </cr-flex>
        <cr-h2> 8. Datenschutz </cr-h2>
        <cr-flex space="md">
          <cr-text>
            Informationen zur Verarbeitung deiner personenbezogenen Daten auf dem Chancencampus findest du in unseren
            Datenschutzinformationen unter
            <cr-link href="${projectConfig.get('NETZ_URL')}privacy">${projectConfig.get('NETZ_URL')}privacy</cr-link>.
          </cr-text>
        </cr-flex>
      </cr-flex>
    `;
  }
}
